import React from 'react';

import { makeStyles, Theme } from '@material-ui/core';
import { Translate } from 'react-localize-redux';

import { Typography } from '@fd/ui/atoms/Typography';

import AuditLogsWrapper from './AuditLogsWrapper';

const useStyles = makeStyles((theme: Theme) => ({
  AuditLogsButton: {
    textTransform: 'none',
    textDecoration: 'none',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    paddingLeft: theme.spacing(2),
    fontSize: '14px',
  },
}));

export type AuditLogsButtonProps = {
  auditLogsFilter?: { type: string; value: string };
};

export const AuditLogsButton = ({ auditLogsFilter }: AuditLogsButtonProps) => {
  const classes = useStyles();
  return (
    <AuditLogsWrapper auditLogsFilter={auditLogsFilter}>
      <Typography className={classes.AuditLogsButton} variant="caption">
        <Translate id={'Audit_logs'} />
      </Typography>
    </AuditLogsWrapper>
  );
};
